import { serializeQueryParams } from '@src/services/dashboard';
import { apiSlice } from '../../api/apiSlice';
import { PlanListParams, PlanListResponse } from './planListApiSliceTypes';

const planListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPlanList: builder.query<PlanListResponse, PlanListParams>({
            query: (params) => {
                return {
                    url: `/plans?${serializeQueryParams(params)}`,
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                };
            },

            providesTags: (result) =>
                result?.data?.items
                    ? [
                          ...result.data.items.map((plan) => ({
                              type: 'plans' as const,
                              id: plan.id,
                          })),
                          { type: 'plans', id: 'LIST' },
                      ]
                    : [{ type: 'plans', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetPlanListQuery, useLazyGetPlanListQuery } =
    planListApiSlice;
